'use strict';

exports.__esModule = true;

var _react = require('react');

exports.default = (0, _react.createContext)({});
module.exports = exports['default'];